/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-shadow */
export enum LetterType {
  OpenEnrollmentNotification = 'OPENENROLLMENTNOTIFICATION',
  OeChangeNotice = 'OECHANGENOTICE',
  OpenEnrollmentNotificationRateSheet = 'OPENENROLLMENTNOTIFICATIONRATESHEET',
  OeChangeNoticeRateSheet = 'OECHANGENOTICERATESHEET',
  OePacket = 'OPENENROLLMENTPACKET'
}
